import { render, staticRenderFns } from "./VehicleAppsCard.vue?vue&type=template&id=47a1fd08"
import script from "./VehicleAppsCard.vue?vue&type=script&lang=js"
export * from "./VehicleAppsCard.vue?vue&type=script&lang=js"
import style0 from "./VehicleAppsCard.vue?vue&type=style&index=0&id=47a1fd08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports